export default "__VITE_ASSET__Dm8Fq7_v__"